import { useCallback, useMemo } from "react";
import { PrayerTableCell } from "../components/PrayerTable/PrayerTableCell";
import { NoDataMessage, NoMonthSelectedMessage } from "../components/ErrorMessages";
import { PrayerTable } from "../components/PrayerTable/PrayerTable";

export const usePrayerCalendarUI = ({
  Month,
  TimeTableMonthFullYear,
  isToday,
  translatedPrayerNames,
  mainHeaders,
  subHeaders,
  monthMethod,
  ShowHightLight,
  rgba_first_bg,
  rgba_first_text,
  rgba_second_bg,
  rgba_second_text,
  rgba_light_bg,
  rgba_light_text,
  rgba_odd_bg,
  rgba_even_bg,
  rgba_even_text,
  rgba_odd_text,
  rgba_border_clr,
  rgba_border_size,
  rgba_border_style,
  HijraLocale,
  hijraLocale,
  show
}: any) => {
  // Memoized cell renderer
  const renderCell = useCallback(
    (content: React.ReactNode, key?: string, isToday?: boolean) => (
      <PrayerTableCell
        content={content}
        isToday={isToday}
        rgba_light_bg={rgba_light_bg}
        rgba_light_text={rgba_light_text}
        key={key}
      />
    ),
    [rgba_light_bg, rgba_light_text]
  );

  // Highlight row cells
  const highlightRow = useMemo(() => {
    if (!ShowHightLight) return undefined;
    return Array(12).fill(null).map((_, i) => 
      renderCell(i === 0 ? "0 Highlight 2222" : "5:19 AM", `highlight-${i}`)
    );
  }, [ShowHightLight, renderCell]);

  // Error states
  const errorState = useMemo(() => {
    if (TimeTableMonthFullYear.length === 0) {
      return <NoDataMessage />;
    }
    if (!Month || (Month.length === 0 && TimeTableMonthFullYear.length > 0)) {
      return <NoMonthSelectedMessage />;
    }
    return null;
  }, [Month, TimeTableMonthFullYear]);

  // Main table component
  const prayerTable = useMemo(() => (
    <PrayerTable
      prayers={Month}
      show={show}
      isToday={isToday}
      HijraLocale={HijraLocale}
      hijraLocale={hijraLocale}
      renderCell={renderCell}
      mainHeaders={mainHeaders}
      subHeaders={subHeaders}
      firstRowBg={`rgba(${rgba_first_bg.r}, ${rgba_first_bg.g}, ${rgba_first_bg.b}, ${rgba_first_bg.a})`}
      firstRowText={`rgba(${rgba_first_text.r}, ${rgba_first_text.g}, ${rgba_first_text.b}, ${rgba_first_text.a})`}
      secondRowBg={`rgba(${rgba_second_bg.r}, ${rgba_second_bg.g}, ${rgba_second_bg.b}, ${rgba_second_bg.a})`}
      secondRowText={`rgba(${rgba_second_text.r}, ${rgba_second_text.g}, ${rgba_second_text.b}, ${rgba_second_text.a})`}
      highlightRow={highlightRow}
      translatedPrayerNames={translatedPrayerNames}
      monthMethod={monthMethod}
    />
  ), [Month, show, isToday, HijraLocale, hijraLocale, renderCell, mainHeaders, 
      subHeaders, rgba_first_bg, rgba_first_text, rgba_second_bg, rgba_second_text, 
      highlightRow, translatedPrayerNames, monthMethod]);

  return {
    errorState,
    prayerTable,
    rgba_odd_bg,
    rgba_even_bg,
    rgba_even_text,
    rgba_odd_text,
    rgba_border_clr,
    rgba_border_size,
    rgba_border_style,
    rgba_light_bg,
    rgba_light_text
  };
};